<template>
  <svg
    v-if="isVerified"
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 14.3906C10.866 14.3906 14 11.2566 14 7.39063C14 6.27283 13.738 5.21623 13.2721 4.27888L7.24412 10.3068L6.53701 11.0139L5.8299 10.3068L2.74992 7.22684L4.16414 5.81263L6.53701 8.1855L12.1129 2.60958C10.8355 1.24406 9.01742 0.390625 7 0.390625C3.13401 0.390625 0 3.52463 0 7.39063C0 11.2566 3.13401 14.3906 7 14.3906Z"
      fill="#54C774"
    />
  </svg>
  <svg
    v-else
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 14.3906C10.866 14.3906 14 11.2566 14 7.39063C14 3.52463 10.866 0.390625 7 0.390625C3.13401 0.390625 0 3.52463 0 7.39063C0 11.2566 3.13401 14.3906 7 14.3906ZM10.5301 9.51093L8.41881 7.39963L10.5374 5.28107L9.12315 3.86685L7.0046 5.98541L4.87326 3.85408L3.45905 5.26829L5.59038 7.39962L3.4663 9.52371L4.88051 10.9379L7.0046 8.81384L9.1159 10.9251L10.5301 9.51093Z"
      fill="#DB3713"
    />
  </svg>
</template>

<script setup>
import { defineProps } from 'vue';
defineProps({
  isVerified: {
    type: Boolean,
    required: true,
  },
});
</script>
